import { homeRoutes } from './Home/routes';
import { IntegratedAppsRoutes } from './IntegratedApps/routes';
import { navigationRoute } from './Notifications/routes';
import { policyRoutes } from './Policies/routes';
import { postDetailsRoute } from './PostDetails/routes';
import { shareLinkRoutes } from './ShareLink/routes';
import { supportRoute } from './Support/routes';

export const commonRoutes = [
  ...homeRoutes,
  postDetailsRoute,
  ...policyRoutes,
  supportRoute,
  ...shareLinkRoutes,
  ...navigationRoute,
  ...IntegratedAppsRoutes,
];
